import React from 'react';

import l10n from "../../../l10n/localization";

import {Button, Table} from "react-materialize";
import Loader from "../../common/Loader";
import {connect} from "react-redux";
import UnderwriterRateForm from "../../forms/UnderwriterRateForm";
import RateItem from "./RateItem";
import * as underwriterRateActions from "../../../actions/underwriterRate";
import * as creationActions from "../../../actions/creation";

class RateTable extends React.Component {

    componentDidMount() {
        this.props.dispatch(underwriterRateActions.fetchRates(this.props.underwriter.item.id, true));
    }

    render() {
        if (this.props.loading || this.props.rates === undefined) {
            return (<div><Loader /></div>)
        }

        return (
            <Table bordered>
                <thead>
                <tr>
                    <th data-field="name">{l10n.underwriter.rate.name}</th>
                    <th data-field="rate">{l10n.underwriter.rate.rate}</th>
                    <th data-field="rate">{l10n.underwriter.rate.yearOfAddition}</th>
                    <th data-field="actions">{l10n.common.actions}</th>
                </tr>
                </thead>

                <tbody>
                {this.props.rates.map((item, index) => (
                    <RateItem {...this.props} item={item} underwriter={this.props.underwriter} key={index} depth={this.props.depth + 1} openDrawer={this.props.openDrawer} />
                ))}
                </tbody>

                <tfoot className="pull-left pt20">
                    <Button type="button" floating onClick={() => this.props.openDrawer(UnderwriterRateForm, {underwriter: this.props.underwriter.item, item: null}, creationActions.destroyingnewlyCreatedUnderwriterRate())} icon="add" className="add-button small"/>
                </tfoot>
            </Table>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        rates: state.underwriterRate.underwriterRates,
        loading: state.underwriterRate.loading,
        deletingUnderwriterrate: state.underwriterRate.deleting
    });
})(RateTable);



// WEBPACK FOOTER //
// ./src/components/underwriter/rates/RateTable.js